/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerAssertComponent', [
    '$timeout',
    'DesignerComponent',
    'DesignerSchema',

    function ($timeout, DesignerComponent, DesignerSchema) {
      function DesignerAssertComponent() {
        DesignerComponent.apply(this);

        // this.predicates = {
        //     match_type: null,
        //     expressions: []
        // };
      }

      DesignerAssertComponent.prototype = new DesignerComponent();

      DesignerAssertComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.defaults(this, this.defaults);

        const predicates = {};
        predicates.match_type = this.predicates.match_type;
        predicates.expressions = this.predicates.expressions;

        _.extend(data, {
          message: this.message,
          predicates,
        });

        return data;
      };

      DesignerAssertComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerAssertComponent.prototype.setData = function (data) {
        this.message = data.message;
        this.predicates = data.predicates;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerAssertComponent.prototype.getSchema = function () {
        const schema = DesignerComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerAssertComponent;
    },
  ]);
})(window.angular);
